import React, { ReactNode, useRef } from 'react';
import clsx from 'clsx';
import { AriaTabPanelProps, useTabPanel } from 'react-aria/useTabList';
import { TabListState } from 'react-stately/useTabListState';
import styles from '@danske/sapphire-css/components/tabs/tabs.module.css';
import { useFocusRing } from 'react-aria/useFocusRing';
import { AriaLabelingPropsKeys } from '../../utils/types';

interface TabPanelProps<T>
  extends Pick<AriaTabPanelProps, 'id' | AriaLabelingPropsKeys> {
  children: ReactNode;
  state: TabListState<T>;
  isSelected: boolean;
  isVisible?: boolean;
}

export function TabPanel<T>({
  children,
  state,
  isSelected,
  isVisible = true,
  ...otherProps
}: TabPanelProps<T>): JSX.Element {
  const ref = useRef(null);
  const { tabPanelProps } = useTabPanel(otherProps, state, ref);
  const { focusProps, isFocusVisible } = useFocusRing();

  return (
    <div
      ref={isSelected ? ref : null}
      {...(isSelected ? tabPanelProps : {})}
      {...(isSelected ? focusProps : {})}
      className={clsx(styles['sapphire-tab-panel'], styles['js-focus'], {
        [styles['is-focus']]: isFocusVisible && isSelected,
      })}
      style={isVisible ? undefined : { display: 'none' }}
    >
      {children}
    </div>
  );
}
